window.site = (window.site || {});

/**
 * Init Offers Space Galleries with Swiper
 * @class Site
 * @static
 */
site.OffersSpaceGalleries = (function OffersSpaceGalleries() {

  'use strict';

  var inited = false;

  function initSwiper(container) {
    if (!container) return null;
    if (container.classList.contains('swiper')) return null;

    const images = Array.from(container.querySelectorAll('img'));
    if (images.length === 0) return null;

    const wrapper = document.createElement('div');
    wrapper.className = 'swiper-wrapper';

    images.forEach((img) => {
      const slide = document.createElement('div');
      slide.className = 'swiper-slide';
      slide.appendChild(img.cloneNode(true));
      wrapper.appendChild(slide);
    });

    while (container.firstChild) {
      container.removeChild(container.firstChild);
    }

    container.classList.add('swiper');
    container.appendChild(wrapper);

    const prevBtn = document.createElement('div');
    prevBtn.className = 'swiper-button-prev';
    container.appendChild(prevBtn);

    const nextBtn = document.createElement('div');
    nextBtn.className = 'swiper-button-next';
    container.appendChild(nextBtn);

    return new window.Swiper(container, {
      modules: [window.SwiperModules.Navigation],
      slidesPerView: 1,
      loop: true,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
    });
  }

  var init = function () {
    if (inited) {
      return false;
    }

    inited = true;

    const $gallery = document.querySelector('.space-offers .offers-gallery.is-active');

    if ($gallery) {
      const $images = Array.from($gallery.querySelectorAll('img'));

      if ($images.length > 0) {
        setTimeout(function() {
          initSwiper($gallery);
        }, 500);
      }
    }

    const $descriptions = document.querySelectorAll('.offers-description');

    if ($descriptions) {
      $descriptions.forEach(($description) => {
        const $titleDescription = $description.querySelector('.offers-desc-title');

        $titleDescription.addEventListener('click', () => {
          if (!$description.classList.contains('is-active')) {
            const offerId = $description.getAttribute('data-offer');

            $descriptions.forEach(($loopDescription) => {
              $loopDescription.classList.remove('is-active');
            });

            $description.classList.add('is-active');
            const currentGallery = document.querySelector('.space-offers .offers-gallery.is-active');
            currentGallery.classList.remove('is-active');

            const $descriptionGalleries = Array.from(document.querySelectorAll('.space-offers .offers-gallery'));
            $descriptionGalleries.forEach(($descriptionGallery) => {
              if ($descriptionGallery.getAttribute('data-offer') === offerId) {
                $descriptionGallery.classList.add('is-active');
                window.scrollTo({
                  top: $descriptionGallery.offsetTop,
                  behavior: "smooth"
                });

                const $images = Array.from($descriptionGallery.querySelectorAll('img'));
                if ($images.length > 0) {
                  initSwiper($descriptionGallery);
                }
              }
            });
          }
        });
      });
    }

    return true;

  };

  return {
    init: init,
    initSwiper: initSwiper,
  };

}());
